import React from 'react';
import { Title } from './styles';

const HomeCollectionHeader = () => {
  return  <Title>Lista de responsables de pago</Title>;
};

export default HomeCollectionHeader;
